import { render, staticRenderFns } from "./resetPassModel.vue?vue&type=template&id=4e92ead8&scoped=true"
import script from "./resetPassModel.vue?vue&type=script&lang=js"
export * from "./resetPassModel.vue?vue&type=script&lang=js"
import style0 from "./resetPassModel.vue?vue&type=style&index=0&id=4e92ead8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e92ead8",
  null
  
)

export default component.exports